import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import AcceptButton from './accept_button';
import RejectButton from './reject_button';
import AcceptInfo from './accept_info';
import './task_offer_buttons.scss';

class TaskOfferButtons extends Component {
  constructor(props) {
    super(props);

    this.renderChooseButtons = this.renderChooseButtons.bind(this);
    this.accept = this.accept.bind(this);
    this.reject = this.reject.bind(this);
  }

  accept() {
    const { offerTaskAccept, taskId } = this.props;
    offerTaskAccept(taskId);
  }

  reject() {
    const { offerTaskDecline, taskId } = this.props;
    offerTaskDecline(taskId);
  }

  renderChooseButtons() {
    return (
      <div className="task-offer-buttons">
        <AcceptButton onClick={this.accept} />
        <RejectButton onClick={this.reject} />
      </div>
    );
  }

  render() {
    const { assignedCompany } = this.props;

    if (_.get(assignedCompany, 'type_task_user_status.code') === 'pending') {
      return this.renderChooseButtons();
    }

    return <AcceptInfo assignedCompany={assignedCompany} />;
  }
}

TaskOfferButtons.propTypes = {
  assignedCompany: PropTypes.shape({
    type_task_user_status: PropTypes.shape({
      code: PropTypes.string,
    }),
  }),
  offerTaskAccept: PropTypes.func,
  offerTaskDecline: PropTypes.func,
  taskId: PropTypes.number,
};

export default TaskOfferButtons;
